import React, {  } from 'react';
import {Redirect} from 'react-router-dom'

import { auth } from '../firebase';
import fakeAuth from './autha';

import { Input, Button } from "antd";

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});


class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      error: null,
    }

  }

  //debug purpose
  componentDidMount() {
    // this.loginla()
    // console.log("login success")
  }

  state = {
    redirectToReferrer: false
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    // const {history} = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({
          email: '',
          password: '',
          error: null,
        });

        this.loginla();
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  loginla = () => {
    fakeAuth.authenticate(() => {
      this.setState(() => ({
        redirectToReferrer: true
      }))
    })
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { redirectToReferrer } = this.state

    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    if (redirectToReferrer === true) {
      return <Redirect to={from} />
    }

    return (
      <div className="loga">
        <h1>Sign In</h1>
        {/* <Button onClick={this.loginla}>CHEAT LOG IN</Button> */}

        <form className="foga">

          <Input
            size="large"
            className="loga"
            value={email}
            onChange={event => this.setState(byPropKey('email', event.target.value))}
            type="text"
            placeholder="Email Address"
          />
          <Input
            size="large"
            className="loga"
            value={password}
            onChange={event => this.setState(byPropKey('password', event.target.value))}
            type="password"
            placeholder="Password"
          />

          <Button type="primary" className="buttona" disabled={isInvalid} onClick={this.onSubmit}>
            Sign In
        </Button>

    {error && <p>{error.message}</p>}
        </form>


      </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/views/login.js